import { useState, useEffect, useCallback } from 'react';
import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';

export default function usePersonLinkBatch(ids) {
  const [linkStatusMap, setLinkStatusMap] = useState({});
  const [fetchTick, setFetchTick] = useState(0);
  const idsKey = ids?.length ? ids.join(',') : '';

  useEffect(() => {
    if (!idsKey) return;
    axios
      .get(`${APICONSTANTS.batchPersonLinkStatus}?ids=${idsKey}`)
      .then(({ data }) => setLinkStatusMap(data))
      .catch(() => {});
  }, [idsKey, fetchTick]);

  const refetch = useCallback(() => setFetchTick((t) => t + 1), []);

  return { linkStatusMap, refetch };
}
